"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formats = void 0;
var _xeUtils = _interopRequireDefault(require("xe-utils"));
var _log = require("../../tools/log");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var VXEFormatsStore = /*#__PURE__*/function () {
  function VXEFormatsStore() {
    _classCallCheck(this, VXEFormatsStore);
    this.store = {};
  }
  _createClass(VXEFormatsStore, [{
    key: "mixin",
    value: function mixin(options) {
      var _this = this;
      _xeUtils.default.each(options, function (item, key) {
        _this.add(key, item);
      });
      return VXEFormatsStore;
    }
  }, {
    key: "get",
    value: function get(name) {
      return this.store[name];
    }
  }, {
    key: "add",
    value: function add(name, render) {
      var conf = this.store[name];
      // 兼容
      if (_xeUtils.default.isFunction(render)) {
        // if (process.env.NODE_ENV === 'development') {
        //   warnLog('vxe.error.delProp', ['formats -> callback', 'cellFormatMethod'])
        // }
        render = {
          cellFormatMethod: render
        };
      }

      // 检测是否覆盖
      if (process.env.NODE_ENV === 'development') {
        var confKeys = _xeUtils.default.keys(conf);
        _xeUtils.default.each(render, function (item, key) {
          if (confKeys.includes(key)) {
            (0, _log.warnLog)('vxe.error.coverProp', [name, key]);
          }
        });
      }
      this.store[name] = conf ? _xeUtils.default.merge(conf, render) : render;
      return VXEFormatsStore;
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      delete this.store[name];
      return VXEFormatsStore;
    }
  }]);
  return VXEFormatsStore;
}();
var formats = new VXEFormatsStore();
exports.formats = formats;
if (process.env.NODE_ENV === 'development') {
  Object.assign(formats, {
    _name: 'Formats'
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vxe-table@3.7.6/~/vxe-table/lib/v-x-e-table/src/formats.js
// module id = 293
// module chunks = 75